import { useEffect, useState } from "react";
import ScrollToTop from "../../../../components/scrollToTop/scrollToTop";
import { FaEdit, FaTimes } from "react-icons/fa";
import "./clients.css";
import axios from "axios";
import Swal from "sweetalert2";
import FormClient from "./FormClient";
import DeleteClients from "./deleted-clients";

function Clients() {

  const [clientsData, setClientsData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage, setDataPerPage] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [updateTrigger, setUpdateTrigger] = useState(false);
  const [viewDeleteClients, setDeleteClients] = useState(false);

  const [statusModal, setStatusModal] = useState(false);
  const [currentClient, setCurrentClient] = useState({});


  const filteredData = searchValue
    ? clientsData.filter((data) =>
        data.name.toUpperCase().includes(searchValue.toUpperCase())
      )
    : clientsData;

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;

  const currentData = filteredData.slice(indexOfFirstData, indexOfLastData);

  const totalPageCount = Math.ceil(filteredData.length / dataPerPage);
  const pageNumbers = [];
  const maxPageNumbersToShow = 20;

  let startPage, endPage;
  if (totalPageCount <= maxPageNumbersToShow) {
    startPage = 1;
    endPage = totalPageCount;
  } else {
    startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
    endPage = Math.min(totalPageCount, startPage + maxPageNumbersToShow - 1);

    if (endPage - startPage < maxPageNumbersToShow) {
      startPage = endPage - maxPageNumbersToShow + 1;
    }
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  useEffect(() => {
    getClients();
  }, [updateTrigger]);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearch = () => {
    const input = document.getElementById("searchInput");
    setSearchValue(input.value.trim());
  };

  const showEntries = (e) => {
    setDataPerPage(e.target.value);
  };

  const getClients = async() => {
    try {
      const url = `${process.env.REACT_APP_URL_BACKEND}/api/v1/clients`;
      const token = `Bearer ${sessionStorage.getItem("token")}`;
      const response = await axios.get(url, {headers: {Authorization: token}});

      setClientsData(response.data.body.pallets);

    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Hubo un error", "error");
    }
  }

  const openModal = (currentClient) => {
    setStatusModal(true);
    setCurrentClient(currentClient)
  }

  const closeModal = () => {
    setStatusModal(false);
  }

  const handleCloseModal = (data, statusClose) => {

    if(statusClose === "no-update") {
      setStatusModal(data);
    } else {
      setUpdateTrigger(!updateTrigger);
      setStatusModal(data);
    }
  }

  const handleChangeClients = () => {
    setDeleteClients(!viewDeleteClients)
  }

  const deleteClient = async (client) => {
    try {

      const result = await Swal.fire({
        title: "¿Estás seguro?",
        text: "¡No podrás revertir esto!",
        icon: "warning",
        showDenyButton: true,
        confirmButtonText: "Sí, eliminarlo",
        denyButtonText: "No, cancelar",
        reverseButtons: true,
        buttonsStyling: true,
      });

      if (result.isConfirmed) {
        const url = `${process.env.REACT_APP_URL_BACKEND}/api/v1/clients/delete/${client.id}`;
        const token = `Bearer ${sessionStorage.getItem("token")}`;
  
        await axios.delete(url, { headers: { Authorization: token } });
  
        Swal.fire("¡Eliminado!", "El elemento ha sido eliminado.", "success");
        setUpdateTrigger(!updateTrigger);
      }
      
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
    }
  }


  return (
    <>
      <ScrollToTop />

      {statusModal && 
        <div className="backgroundmodal" onClick={closeModal}>
          <div className="modalWindow" onClick={(e) => e.stopPropagation()}>
            <div className="headerModal">
              {currentClient ? (
                <p>Editar Cliente</p>
              ): (
                <p>Crear Cliente</p>
              )}
            </div>

            <div className="bodyModal">
              <FormClient closeModal={handleCloseModal} currentClient={currentClient} />
            </div>
            
          </div>
        </div>
      }

      <div className="table-responsive">
        <div 
          className="dataTables_wrapper dt-bootstrap4 no-footer"
          id="datatables_wrapper"
        >

          <div className="text-right mb-2 ">
            <button className="btnn" onClick={handleChangeClients}>
              {!viewDeleteClients ? (
                'Ver Eliminados'
              ) : (
                'Ver Activos'
              )}
            </button>
          </div>

          {viewDeleteClients ? (
            <>
              <DeleteClients setUpdateTrigger={setUpdateTrigger} updateTrigger={updateTrigger} />
            </>
          ) : (
            <>
              <div className="text-right mb-4 ">
                <button className="btnn" onClick={() => openModal()}>
                  Añadir Clientes
                </button>
              </div>
              <div className="row justify-content-between mb-2">
                <div className="col-sm-12 col-md-4">
                  <div className="dataTables_length" id="dataTables_length">
                    <label className="d-flex justify-content-start">
                      <span className="mr-2 p-2">Mostrar</span>
                      <select
                        name="datatables_length"
                        aria-controls="datatables_length"
                        className="custom-select custom-select-sm form-control-sm narrow-select p-2"
                        onChange={showEntries}
                      >
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                      <span className="ml-2 p-2">registros</span>
                    </label>
                  </div>
                </div>
                <div className="col-sm-12 col-md-4">
                  <div className="datatables_filter" id="datatables_filter">
                    <label className="d-flex justify-content-end">
                      <span className="mr-2 mt1 p-2">Buscar</span>
                      <input
                        type="search"
                        id="searchInput"
                        className="form-control form-control-sm"
                        placeholder
                        aria-controls="datatables"
                      />
                      <button className="btnn" onClick={handleSearch}>
                        Buscar
                      </button>
                    </label>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <table
                    className="table table-inverse table-hover table-striped table-bordered dataTable no-footer"
                    role="grid"
                    aria-describedby="datatables_info"
                  >
                    <thead>
                      <tr role="row">
                        <th
                          className="sorting"
                          tabIndex={0}
                          aria-controls="datatables"
                          rowSpan={1}
                          colSpan={1}
                          style={{ width: "343.25px" }}
                        >
                          Nombre
                        </th>
                        <th
                          className="sorting"
                          tabIndex={0}
                          aria-controls="datatables"
                          rowSpan={1}
                          colSpan={1}
                          style={{ width: "178.203px" }}
                        >
                          RFC
                        </th>
                        <th
                          className="sorting"
                          tabIndex={0}
                          aria-controls="datatables"
                          rowSpan={1}
                          colSpan={1}
                          style={{ width: "81.2031px" }}
                        >
                          Acciones
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        currentData.length === 0 ? 
                          (
                            <div>
                              <p>No hay registros</p>
                            </div>
                          ) :
                          currentData.map((client) => (
                            <tr key={client.id}>
                              <td>{client.name}</td>
                              <td>{client.rfc}</td>
                              <td>
                                <FaEdit
                                  className="btn-edit"
                                  onClick={() => openModal(client)}
                                />
                                <FaTimes className='deleteButton' onClick={() => { deleteClient(client) }} />
                              </td>
                            </tr>   
                          ))
                      }
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="row">
                <nav aria-label="Page navigation example">
                  <ul className="pagination">
                    <li className="page-item">
                      <button
                        className="page-link"
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                      >
                        Anterior
                      </button>
                    </li>
                    {pageNumbers.map((pageNumber) => (
                      <li className="page-item" key={pageNumber}>
                        <button
                          className="page-link"
                          onClick={() => paginate(pageNumber)}
                        >
                          {pageNumber}
                        </button>
                      </li>
                    ))}
                    <li className="page-item">
                      <button
                        className="page-link"
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === pageNumbers.length}
                      >
                        Siguiente
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </>
          )}
          


        </div>
      </div>
    </>
  )

}

export default Clients;